import React from "react";
import { Box, Dialog, Button, Typography } from "@mui/material";

/**
 * Offered once, after login, to users who haven't chosen a UI yet.
 *
 * Either answer is remembered, so nobody is nagged twice — declining is a real answer, not
 * a "remind me later". Opting in only changes where login lands you; old bookmarks keep
 * working, and the v1 rail has a one-click way back.
 */
const VersionPrompt = ({ open, onAccept, onDecline }) => (
  <Dialog
    open={open}
    // No onClose: clicking away shouldn't silently count as declining, because that answer
    // is stored and they'd never be asked again.
    disableEscapeKeyDown
    PaperProps={{ sx: { borderRadius: "12px", width: 440, maxWidth: "100%" } }}
  >
    <Box sx={{ p: 3.5 }}>
      <Box
        sx={{
          display: "inline-block",
          fontFamily: "'IBM Plex Mono', monospace",
          fontSize: 10.5,
          fontWeight: 500,
          letterSpacing: ".06em",
          color: "#4C4CDD",
          bgcolor: "#EEEEFC",
          borderRadius: "4px",
          px: 1,
          py: 0.375,
          mb: 2,
        }}
      >
        NEW
      </Box>

      <Typography sx={{ fontSize: 19, fontWeight: 600, color: "#1E1E24", mb: 1 }}>
        Try the new console
      </Typography>

      <Typography sx={{ fontSize: 13.5, lineHeight: 1.7, color: "#55555E", mb: 1 }}>
        Every candidate in one table, with screening and interviews on the same screen —
        no more hopping between dashboards. Jobs live in a sidebar, so you pick one once.
      </Typography>

      <Typography sx={{ fontSize: 12.5, lineHeight: 1.7, color: "#8E8E99", mb: 3 }}>
        You can switch back at any time, and your existing links keep working.
      </Typography>

      <Box sx={{ display: "flex", gap: 1.25 }}>
        <Button
          fullWidth
          variant="contained"
          onClick={onAccept}
          disableElevation
          sx={{
            bgcolor: "#4C4CDD",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 13.5,
            py: 1.25,
            borderRadius: "7px",
            "&:hover": { bgcolor: "#3A3AB8" },
          }}
        >
          Try the new console
        </Button>
        <Button
          fullWidth
          variant="outlined"
          onClick={onDecline}
          sx={{
            textTransform: "none",
            fontWeight: 500,
            fontSize: 13.5,
            py: 1.25,
            borderRadius: "7px",
            borderColor: "#E0E0E6",
            color: "#1E1E24",
            "&:hover": { borderColor: "#E0E0E6", bgcolor: "#FAFAFC" },
          }}
        >
          Stay on this one
        </Button>
      </Box>
    </Box>
  </Dialog>
);

export default VersionPrompt;
